"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadView = exports.filterAsyncRouter = exports.default = void 0;

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.json.stringify.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.array.map.js");

var _index = require("@/router/index");

var _index2 = _interopRequireDefault(require("@/layout/index"));

var state = {
  routers: _index.constantRouterMap,
  addRouters: []
};
var mutations = {
  SET_ROUTERS: function SET_ROUTERS(state, routers) {
    state.addRouters = routers; // constantRouterMap.splice(2,0, ...routers) // 动态路由从本地路由列表的第二个位置之后开始插入
    // state.routers = objHeavy(constantRouterMap)

    state.routers = objHeavy(routers);
  }
};
var actions = {
  GenerateRoutes: function GenerateRoutes(_ref, asyncRouter) {
    var commit = _ref.commit;
    commit('SET_ROUTERS', asyncRouter);
  }
}; // 去除重复的菜单对象

var objHeavy = function objHeavy(arr) {
  var newArr = []; // 存新数组

  var obj = {}; // 存处理后转成字符串的对象

  for (var i = 0; i < arr.length; i++) {
    var keys = Object.keys(arr[i]); // keys.sort(function(a, b) {
    //     return (Number(a) - Number(b));
    // });

    var str = '';

    for (var j = 0; j < keys.length; j++) {
      str += JSON.stringify(keys[j]);
      str += JSON.stringify(arr[i][keys[j]]);
    }

    if (!obj.hasOwnProperty(str)) {
      newArr.push(arr[i]);
      obj[str] = true;
    }
  }

  return newArr;
};

var filterAsyncRouter = function filterAsyncRouter(permissionList) {
  var group_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

  // 传入权限组
  _index.constantRouterMap.filter(function (item, index) {
    if (index >= 2) {
      // 登录、首页不进入判断
      var _item$meta = item.meta,
          meta = _item$meta === void 0 ? {} : _item$meta,
          _item$children = item.children,
          children = _item$children === void 0 ? [] : _item$children;
      item.hidden = true; // 初始时，所有菜单全部隐藏
      // 普通用户-group_id==0  无任何权限

      if (group_id == '0') {
        item.hidden = true;
      } else if (meta.menuId == 'open') {
        // 不加权限控制的  menuId设置为open
        item.hidden = false;
      } else {
        if (meta.menuId) {
          // 第一层路由判断
          if (permissionList.indexOf(meta.menuId) != -1) {
            item.hidden = false;
          }
        } else {
          // 第二层路由判断
          children.map(function (list) {
            list.hidden = true; // 初始时，所有菜单全部隐藏

            if (permissionList.indexOf(list.meta.menuId) != -1) {
              item.hidden = false;
              list.hidden = false;
            }
          });
        }
      }
    }
  });

  return _index.constantRouterMap;
};

exports.filterAsyncRouter = filterAsyncRouter;

var loadView = function loadView(view) {
  return function (resolve) {
    return require(["@/views/".concat(view)], resolve);
  };
};

exports.loadView = loadView;
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;